import React from 'react';
import ReactDOM from 'react-dom';
import './Stylesheets/index.css';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import DocumentStructure from './Structures/DocumentStructure';

// Renders multiple Pages
// TODO:Make it load everything as a separate entity to reduce loads
ReactDOM.render((
    <BrowserRouter basename="/research-community-map">
        <DocumentStructure />
    </BrowserRouter>
), document.getElementById('root'));

// ReactDOM.render(<Authors />, document.getElementById('root'));
registerServiceWorker();
